//
// Copyright 2026 DXOS.org
//
import * as Schema from 'effect/Schema';
import * as Rpc from 'effect/unstable/rpc/Rpc';
import * as RpcGroup from 'effect/unstable/rpc/RpcGroup';
import { protoMessage, serviceError } from './service-rpc.js';
import { protoStruct, protoTimestamp } from './service-schemas.js';
//
// RPC message schemas.
//
export const KeyOption = Schema.Enum({
    NONE: 0,
    TRUNCATE: 1,
    HUMANIZE: 2,
});
export const GetDiagnosticsRequest = Schema.Struct({
    keys: Schema.optional(KeyOption),
});
export const GetDiagnosticsResponse = Schema.Struct({
    timestamp: protoTimestamp,
    diagnostics: protoStruct,
});
export const SystemStatus = Schema.Enum({
    INACTIVE: 0,
    ACTIVE: 1,
});
export const UpdateStatusRequest = Schema.Struct({
    status: SystemStatus,
});
export const QueryStatusRequest = Schema.Struct({
    interval: Schema.optional(Schema.Number),
});
export const QueryStatusResponse = Schema.Struct({
    status: SystemStatus,
});
/**
 * Effect RPC definitions for `dxos.client.services.SystemService`.
 * Service-only payloads use Effect schemas; shared proto types remain protobuf-encoded on the wire.
 */
export class Rpcs extends RpcGroup.make(
/**
 * Get the static config of the client.
 */
Rpc.make('getConfig', {
    success: protoMessage('dxos.config.Config'),
    error: serviceError,
}), 
/**
 * Get the diagnostics snapshot.
 */
Rpc.make('getDiagnostics', {
    payload: GetDiagnosticsRequest,
    success: GetDiagnosticsResponse,
    error: serviceError,
}), 
/**
 * Update the status of the client. Used to re-activate an inactive client.
 */
Rpc.make('updateStatus', {
    payload: UpdateStatusRequest,
    error: serviceError,
}), 
/**
 * Stream the status of the client.
 */
Rpc.make('queryStatus', {
    payload: QueryStatusRequest,
    success: QueryStatusResponse,
    error: serviceError,
    stream: true,
}), 
/**
 * Reset the client.
 */
Rpc.make('reset', {
    error: serviceError,
}), 
/**
 * Get platform Information.
 */
Rpc.make('getPlatform', {
    success: protoMessage('dxos.client.services.Platform'),
    error: serviceError,
})).prefix('SystemService.') {
}
//# sourceMappingURL=SystemService.js.map